/**
 * Centralized route definitions.
 * All navigation (router.push, Link href, redirect) should reference these
 * instead of hardcoding path strings. Renames become single-line changes.
 */

export const E_Page = {
  // App routes (authenticated)
  Shell: "/app/shell",

  // Landing / public
  Landing: "/",
  Pricing: "/pricing",
  AutonomousTrading: "/autonomous-trading",
  Blog: "/blog",
  Onboarding: "/onboarding",
} as const;

export const routes = {
  shellThread: (cuid: string) => `${E_Page.Shell}/${cuid}` as const,
  shellPrompt: (message: string) =>
    `${E_Page.Shell}?${new URLSearchParams({ message }).toString()}` as const,
  stock: (symbol: string) =>
    `${E_Page.Shell}/stocks/${encodeURIComponent(symbol)}` as const,
  blogPost: (id: string) => `/blog/${id}` as const,
  share: (cuid: string) => `/share/${cuid}` as const,
  authSignIn: (redirect?: string) =>
    redirect
      ? (`/api/auth/sign-in?${new URLSearchParams({ redirect }).toString()}` as const)
      : ("/api/auth/sign-in" as const),
} as const;
